export default "__VITE_ASSET__03df8f6f__"